const PICKER_WIDTH = { min: 400, max: 480, default: 440 };
const SIMPLE_PICKER_WIDTH = { min: 238, max: 272, default: 238 };

export const FILTER_WIDTH_BOUNDS = {
  retorno: SIMPLE_PICKER_WIDTH,
  previsao: SIMPLE_PICKER_WIDTH,
  bairro: SIMPLE_PICKER_WIDTH,
  cliente: SIMPLE_PICKER_WIDTH,
  cidade: SIMPLE_PICKER_WIDTH,
  tipoOS: SIMPLE_PICKER_WIDTH,
  sla: SIMPLE_PICKER_WIDTH,
  equipamento: SIMPLE_PICKER_WIDTH,
  status: SIMPLE_PICKER_WIDTH,
  tecnicoInicial: SIMPLE_PICKER_WIDTH,
  defeitoDescricao: SIMPLE_PICKER_WIDTH,
  defeitoAlert: SIMPLE_PICKER_WIDTH,
  defeitoClassification: SIMPLE_PICKER_WIDTH,
  defeitoSeverity: SIMPLE_PICKER_WIDTH,
  osFutura: { min: 260, max: 280, default: 272 },
  default: PICKER_WIDTH,
};

export function getFilterWidthHint(filterType) {
  return (FILTER_WIDTH_BOUNDS[filterType] || FILTER_WIDTH_BOUNDS.default).default;
}

export function clampPopoverWidth(width, filterType) {
  const bounds = FILTER_WIDTH_BOUNDS[filterType] || FILTER_WIDTH_BOUNDS.default;
  const viewportMax = window.innerWidth - 16;
  const max = Math.min(bounds.max, viewportMax);
  const min = Math.min(bounds.min, max);
  return Math.min(max, Math.max(min, width));
}

export function measurePopoverWidth(rootEl, filterType) {
  const bounds = FILTER_WIDTH_BOUNDS[filterType] || FILTER_WIDTH_BOUNDS.default;
  if (!rootEl) return bounds.default;

  const modal = rootEl.querySelector('.bsf-popover-modal');
  if (!modal) return bounds.default;

  const saved = {
    width: rootEl.style.width,
    maxWidth: rootEl.style.maxWidth,
    minWidth: rootEl.style.minWidth,
    visibility: rootEl.style.visibility,
    position: rootEl.style.position,
    left: rootEl.style.left,
  };

  rootEl.style.visibility = 'hidden';
  rootEl.style.position = 'fixed';
  rootEl.style.left = '-9999px';
  rootEl.style.width = 'auto';
  rootEl.style.minWidth = `${bounds.min}px`;
  rootEl.style.maxWidth = `${bounds.max}px`;

  const measured = Math.ceil(modal.getBoundingClientRect().width);

  rootEl.style.width = saved.width;
  rootEl.style.maxWidth = saved.maxWidth;
  rootEl.style.minWidth = saved.minWidth;
  rootEl.style.visibility = saved.visibility;
  rootEl.style.position = saved.position;
  rootEl.style.left = saved.left;

  return clampPopoverWidth(measured, filterType);
}
